import { FormattedMessage } from "react-intl";

const ShowPersonalDetails = (props: any): React.JSX.Element => {
  return (
    <div className="personal-details__component--read-only regular-user">
      <div>
        <span className="personal-details__label">
          <FormattedMessage tagName="span" id="settings-username" />
        </span>
        <span className="personal-details__text">{props.username}</span>
      </div>
      <div>
        <span className="personal-details__label">
          <FormattedMessage tagName="span" id="settings-title" />
        </span>
        <span className="personal-details__text">{props.title}</span>
      </div>
      <div>
        <span className="personal-details__label">
          <FormattedMessage tagName="span" id="settings-firstname" />
        </span>
        <span className="personal-details__text">{props["firstName"]}</span>
      </div>
      <div>
        <span className="personal-details__label">
          <FormattedMessage tagName="span" id="settings-lastname" />
        </span>
        <span className="personal-details__text">{props["lastName"]}</span>
      </div>
      <div>
        <span className="personal-details__label">
          <FormattedMessage tagName="span" id="settings-birth" />
        </span>
        <span className="personal-details__text">{props["dateOfBirth"]}</span>
      </div>
      <div>
        <span className="personal-details__label">
          <FormattedMessage tagName="span" id="settings-currency" />
        </span>
        <span className="personal-details__text">{props["currencyCode"]}</span>
      </div>
    </div>
  );
};

export default ShowPersonalDetails;
